module.exports = __webpack_public_path__ + "img/progress_056.8ce6c7d6.png";